import type { PicklistItem } from '@efdigital/ll-addon-data';
import { DataTypeSystem } from '@efdigital/ll-addon-data/data-types';
import { page } from '@efdigital/ll-admin-v2/data/json-api';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import { deleteRecord, query } from '@warp-drive/utilities/json-api';

export function queryPicklistItemsByGroupName(
  groupName: string,
  { offset = 0, limit = 500 }: { offset?: number; limit?: number } = {}
) {
  return query<PicklistItem>(
    DataTypeSystem.PicklistItem,
    {
      'filter[group]': groupName,
      ...page({ offset, limit }),
    },
    jsonApiOptions
  );
}

export function deletePicklistItem(item: PicklistItem) {
  return deleteRecord(item, jsonApiOptions);
}
